export const toKebabCase = (str: string): string => {
  return str
    .trim()
    .replace(/([a-z0-9])([A-Z])|\s+/g, "$1-$2")
    .replace(/_/g, "-")
    .toLowerCase();
};
